import { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { products } from "@/mocks/products";

export default function Cart() {
  const [items, setItems] = useState(
    products.slice(0, 2).map((p) => ({ ...p, qty: 1 }))
  );

  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <Layout>
      <section>
        <div className="shell pt-16 pb-12">
          <p className="eyebrow mb-4">Your Bag</p>
          <h1 className="font-display text-5xl md:text-6xl text-black">Bag</h1>
        </div>

        <div className="shell pb-24 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-8 border-t border-stone">
            {items.length === 0 && (
              <p className="py-20 text-graphite">Your bag is empty. <Link to="/shop" className="border-b border-black">Continue shopping</Link></p>
            )}
            {items.map((item, idx) => (
              <div key={item.id} className="py-8 border-b border-stone grid grid-cols-12 gap-6 items-center">
                <div className="col-span-3">
                  <div className="w-full aspect-square bg-stone overflow-hidden">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover object-top" />
                  </div>
                </div>
                <div className="col-span-6">
                  <p className="text-sm text-black">{item.name}</p>
                  <p className="mt-1 text-xs text-graphite">{item.material}</p>
                  <div className="mt-4 inline-flex items-center border border-black/15">
                    <button className="w-9 h-9 flex items-center justify-center cursor-pointer" onClick={() => {
                      const c = [...items]; c[idx] = { ...c[idx], qty: Math.max(1, c[idx].qty - 1) }; setItems(c);
                    }}><i className="ri-subtract-line"></i></button>
                    <span className="w-9 text-center text-sm">{item.qty}</span>
                    <button className="w-9 h-9 flex items-center justify-center cursor-pointer" onClick={() => {
                      const c = [...items]; c[idx] = { ...c[idx], qty: c[idx].qty + 1 }; setItems(c);
                    }}><i className="ri-add-line"></i></button>
                  </div>
                </div>
                <div className="col-span-3 text-right">
                  <p className="text-sm text-black">${(item.price * item.qty).toLocaleString()}</p>
                  <button onClick={() => setItems(items.filter((_, i) => i !== idx))} className="mt-4 text-xs text-graphite hover:text-black cursor-pointer">Remove</button>
                </div>
              </div>
            ))}
          </div>

          <div className="md:col-span-4">
            <div className="bg-stone p-8">
              <p className="eyebrow mb-6">Summary</p>
              <div className="flex justify-between text-sm text-black py-2">
                <span>Subtotal</span><span>${subtotal.toLocaleString()}</span>
              </div>
              <div className="flex justify-between text-sm text-graphite py-2">
                <span>Shipping</span><span>Complimentary</span>
              </div>
              <div className="flex justify-between text-base text-black pt-4 border-t border-black/10 mt-4">
                <span>Total</span><span>${subtotal.toLocaleString()}</span>
              </div>
              <button className="mt-8 w-full bg-ink text-canvas py-4 text-[12px] tracking-[0.24em] uppercase whitespace-nowrap cursor-pointer hover:bg-black">
                Secure Checkout
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}